module.exports = __webpack_public_path__ + "img/slack.56da63bb.png";